import { API_URL } from '../../../../../actions/utilAction';
import { actionCreator,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    extractDataFromObject,
    jsonApiHeader,
    showSuccessMessage,
    showErrorMessage,
    showWarningMessage,
} from '../../../../../actions/utilAction';

export { jsonApiHeader,
    actionCreator,
    checkHttpStatus,
    createSearchUrl,
    create_post_data,
    showSuccessMessage,
    showErrorMessage,
    extractDataFromObject,
    showWarningMessage,
   API_URL,
};

export const GET_MASTERCLINICALROOM = `${API_URL}/api/MasterClinicalRoom/GetMasterClinicalRoom`;
export const POST_MASTERCLINICALROOM = `${API_URL}/api/MasterClinicalRoom/SaveMasterClinicalRoom`;
export const GET_MASTERCLINICALROOM_BY_ID = `${API_URL}/api/MasterClinicalRoom/GetMasterClinicalRoomById`;
export const DELETE_MASTERCLINICALROOM = `${API_URL}/api/MasterClinicalRoom/DeleteMasterClinicalRoom`;

export const masterClinicalRoomActionTypes = {
  get_master_data: createRequestActionTypes('GET_MASTER_DATA'),
  get_master_clinicalroom: createRequestActionTypes('GET_MASTERCLINICALROOM'),
  post_master_clinicalroom: createRequestActionTypes('POST_MASTERCLINICALROOM'),
  get_master_clinicalroom_by_id: createRequestActionTypes('GET_MASTERCLINICALROOM_BY_ID'),
  delete_master_clinicalroom: createRequestActionTypes('DELETE_MASTERCLINICALROOM'),
};

export const MODULE = 'MASTER_CLINICALROOM';





// WEBPACK FOOTER //
// ./src/modules/Masters/components/masterClinicalRoom/constants/ApiConstants.js